
<!--
 * @Author: your name
 * @Date: 2022-03-17 13:43:58
 * @LastEditTime: 2022-03-24 23:56:07
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\intro\BlogDetails.vue
-->
<template>
  <div>
    <div class="all">
      <div class="BlogDetals-header"></div>
      <div
        class="BlogDetals-all"
        :style="{
          height: divHeight,
        }"
      >
        <div class="BlogDetals" ref="element">
          <div class="BlogDetals-w">
            <div class="BlogDetals-center">
              <div class="BlogDetals-Announcements">
                <p>
                  <router-link to="/pc/Index">{{
                    $t("navbar.index")
                  }}</router-link>

                  <i>{{ $t("BlogDetals.Announcements[1]") }}</i>
                  <router-link to="/pc/Blog">{{
                    $t("Community.blog")
                  }}</router-link>
                </p>
              </div>
              <div class="BlogDetals-Title">
                <p>
                  {{ blogData.blogTitle }}
                </p>
              </div>
              <div>
                <div class="clearfix">
                  <div class="Blog-right-imgs">
                    <img :src="blogData.avatar" alt="" />
                  </div>
                  <div class="Blog-right-title">
                    <p class="Blog-right-title-p">
                      {{ blogData.createBy }}
                    </p>
                    <p class="Blog-right-p">{{ blogData.createTime }}</p>
                  </div>
                </div>
              </div>
              <div class="BlogDetals-content">
                <p v-html="blogData.text">
                  <!-- {{ $t("BlogDetals.BlogDetals") }} -->
<!--                  {{ data.data.text }}-->
                </p>
              </div>
              <div>
                <div class="Blog-footer">
                  <div class="Blog-footer-title">
                    <p>{{ $t("Blog.join") }}</p>
                  </div>
                  <div class="Blog-footer-title-p">
                    <p>
                      {{ $t("Blog.detail1") }}
                    </p>
                  </div>
                  <div class="clearfix">
                    <el-form
                            ref="emailForm"
                            :model="emailForm"
                            :rules="rules"
                            label-width="120px">
                      <el-form-item prop="mailAddress">
                        <el-input   placeholder="Enter your email address"  v-model="emailForm.email"
                        ></el-input>
                        <el-button @click="subBlog">{{ $t("Blog.subscribe")}}</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="folg1">
              <!-- <div
                class="beijing"
                :style="{
                  width: divHeight,
                  height: divWidth,
                  background: divbackground,
                }"
              > -->
              <div class="Pop-up">
                <div class="Pop-up-img">
                  <img src="../../../assets/pc/intro/插插.png" alt="" />
                </div>
                <div class="Pop-up-p">
                  <p>
                    {{ $t("Popup.Subscription") }}
                  </p>
                </div>
                <div class="Pop-up-Ok" @click="OK">
                  <!-- {{folg}} -->
                  <p>{{ $t("Popup.OK") }}</p>
                </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Blogfooret from "@/components/pc/Blog-fooret.vue";
import { GetBlogDetail, SubBlog } from "@/assets/server/api.js";
export default {
  data() {
    return {
      blogData: [],
      dialogVisible: false,
      email: "",
      emailForm: {
        email: null,
      },
      rules: {
        email: [
          { required: true, message: "Enter your email address", trigger: "change" },
        ],
      },
      // data: "",
      // id: this.$route.query.id,
      // email: "",
      // blogId: "",
      folg1: false,
      // divWidth:0,
      divHeight: 0,
    };
  },

  created() {
    // console.log(this.$route.query.id);
    this.GetBlogDetail(this.$route.query.id);
  },
  updated() {
    setTimeout(() => {
      this.divHeight = this.$refs.element.offsetHeight + 155 + "px";
    }, 500);
  },

  methods: {
    async GetBlogDetail(id) {
      const data = await GetBlogDetail(id);
      if (data.code === 0) {
        data.data.images = data.data.images;
        // console.log(data.data)
        this.blogData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },
    async subBlog() {
      let id = this.blogData.blogId;
      let reg = /\w+@[a-z0-9]+\.[a-z]{2,4}/;
      if (!reg.test(this.emailForm.email)) {
        return this.$message.warning("enter the correct email address");
      }
      let info = id + "/" + this.emailForm.email;
      const data = await SubBlog(info);
      if (data.code === 0) {
        this.emailForm.email = "";
        this.folg1 = true;

      } else {
        this.$message.error(data.msg);
      }
    },

    OK() {
      this.folg1 = false;
    },
  },
  components: {
    Blogfooret,
  },
};
</script>

<style lang="less" >
  .MsoNormalTable {
    width: 100% !important;
  td {
    width: 50px !important;
  }
  img {
    /*width: 650px;*/
    width: 650px !important;
    max-width: 650px  !important;
  }
  }
</style>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.all {
  /*width: 100%;*/
  min-height:1070px;
  height: 100%;
  // padding-bottom: 231px;
  z-index: 10;
}
.BlogDetals-header {
  height: 150px;
  background-color: #4573e7;
  margin-top: 90px;
}
.BlogDetals-all {
  width: 100%;
  // height: 1589px;
  background-color: #fafafa;
  position: relative;
  .BlogDetals {
    width: 100%;
    position: absolute;
    top: -50px;
    left: 0;
    margin-bottom: 235px;
    background-color: #fafafa;
    .BlogDetals-w {
      width: 1200px;
      padding: 50px 0 20px 20px;
      background-color: #fff;
      margin: 0 auto;
      box-sizing: border-box;
      .BlogDetals-center {
        width: 880px;
        /*margin-top: -80px;*/
        margin: 0 auto;
        .BlogDetals-Announcements {
          padding-top: 10px;
          margin-bottom: 15px;
          cursor: pointer;
          p {
            a {
              color: #4573e7;
            }
            font-size: 16px;
            color: #4573e7;
            font-weight: 400;
            line-height: 19px;
            font-family: Microsft Yahei-Regular, Microsft YaHei;
            -webkit-background-clip: text;
            i {
              color: #000;
              margin: 0 10px;
            }
          }
        }
        .BlogDetals-Title {
          font-size: 40px;
          font-weight: 900;
          line-height: 47px;
          margin-bottom: 25px;
          font-family: Microsft Yahei-Regular, Microsft YaHei;
          color: #000;
          word-wrap: break-word;
          -webkit-background-clip: text;
        }
        .Blog-right-imgs {
          width: 40px;
          height: 40px;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .Blog-right-title {
          color: #000;
          float: left;
          margin-left: 20px;
          .Blog-right-title-p {
            font-size: 16px;
            line-height: 19px;
            font-weight: bold;
            -webkit-background-clip: text;
            font-family: Microsft Yahei-Regular, Microsft YaHei;
          }
          .Blog-right-p {
            font-size: 12px;
            color: #6e7887;
            opacity: 0.6;
            font-weight: 400;
            font-family: Poppins-regular, Poppins;
            -webkit-background-clip: text;
            line-height: 14px;
          }
        }
        /*.BlogDetals-content /deep/ span {
          font-size: 14px !important;
          font-family: Poppins-Medium, Poppins !important;
          font-weight: 500 !important;
          color: #737582 !important;
          line-height: 35px !important;
          -webkit-background-clip: text !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .BlogDetals-content /deep/ div {
          font-size: 14px !important;
          font-family: Poppins-Medium, Poppins !important;
          font-weight: 500 !important;
          color: #737582 !important;
          line-height: 35px !important;
          -webkit-background-clip: text !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .BlogDetals-content /deep/ p {
          font-size: 14px !important;
          font-family: Poppins-Medium, Poppins !important;
          font-weight: 500 !important;
          color: #737582 !important;
          line-height: 35px !important;
          -webkit-background-clip: text !important;
          margin: 0 !important;
          padding: 0 !important;
          img {
            display: block !important;
          }
          span {
            font-size: 14px !important;
            font-family: Poppins-Medium, Poppins !important;
            font-weight: 500 !important;
            color: #737582 !important;
            line-height: 35px !important;
            -webkit-background-clip: text !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          div {
            font-size: 14px !important;
            font-family: Poppins-Medium, Poppins !important;
            font-weight: 500 !important;
            color: #737582 !important;
            line-height: 35px !important;
            -webkit-background-clip: text !important;
            margin: 0 !important;
            padding: 0 !important;
          }
        }*/
        .BlogDetals-content {
          margin: 45px 0 120px 0;
          font-size: 14px;
          color: #737582;
          font-weight: 500;
          line-height: 35px;
          font-family: Poppins-Medium, Poppins;
          -webkit-background-clip: text;
          .MsoNormalTable {
            width: 100% !important;
            td {
              width: 50px !important;
            }
            img {
              /*width: 650px;*/
              width: 880px;
              max-width: 880px;
            }
          }
        }
      }
      .BlogDetals-center /deep/ .Blog-footer {
        // margin-bottom: 155px;
        input {
          width: 550px;
        }
        button {
          width: 185px;
          margin-left: 40px;
        }
      }
    }
  }
}
.Blog-footer {
  box-sizing: border-box;
  width: 100%;
  height: 260px;
  background: rgba(69, 115, 231, 0.03);
  border-top: 2px solid #4573e7;
  padding: 48px 50px 59px 50px;
  margin-bottom: 155px;
  .Blog-footer-title {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    line-height: 23px;
    margin-left: 10px;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Bold, Microsoft YaHei;
  }
  .Blog-footer-title-p {
    font-size: 14px;
    color: #4573e7;
    font-weight: 400;
    line-height: 20px;
    margin: 15px 0 40px 10px;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
  }
  input {
    float: left;
    width: 840px;
    height: 50px;
    font-size: 14px;
    padding: 14px 30px 15px 30px;
    border-radius: 30px;
    border: 2px solid #767676;
    color: #999;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    outline: none;
    box-sizing: border-box;
  }
  button {
    float: left;
    border-radius: 31px;
    height: 50px;
    border: 2px solid #4573e7;
    padding: 14px 56px 15px 56px;
    color: #4573e7;
    font-size: 16px;
    font-weight: 400;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    margin-left: 61px;
    box-sizing: border-box;
  }
}
.Pop-up {
  width: 540px;
  height: 280px;
  background: #f4f5f7;
  opacity: 1;
  border-top: 10px solid #4573e7;
  position: absolute;
  /*top: 0;*/
  bottom: 665px;
  /*left: ;*/
  transform: translate(71%, 71%);
  text-align: center;
  z-index: 1;
  .Pop-up-img {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    padding: 36px 0 40px 0;
  }
  .Pop-up-p {
    margin: 27px 0 36px 0;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #2b2d41;
    line-height: 22px;
  }
  .Pop-up-Ok {
    width: 145px;
    height: 50px;
    background: #4573e7;
    border-radius: 5px 5px 5px 5px;
    opacity: 1;
    margin: 0 auto;
    text-align: center;
    line-height: 50px;
    p {
      font-size: 16px;
      font-family: Poppins-SemiBold, Poppins;
      font-weight: 600;
      color: #ffffff;
    }
  }
}
.Blog-footer {
  box-sizing: border-box;
  width: 100%;
  height: 260px;
  background: rgba(69, 115, 231, 0.03);
  border-top: 2px solid #4573e7;
  padding: 48px 50px 59px 50px;
  /*margin-bottom: 289px;*/
  .Blog-footer-title {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    line-height: 23px;
    margin-left: 10px;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Bold, Microsoft YaHei;
  }
  .Blog-footer-title-p {
    font-size: 14px;
    color: #4573e7;
    font-weight: 400;
    line-height: 20px;
    margin: 15px 0 40px 10px;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
  }
  .el-form /deep/ .el-form-item{
    .el-form-item__content{
      margin-left: 0 !important;
    }

  }
  .el-input{
    width: 550px;
    height: 50px;
    float: left;
  }
  .el-input /deep/ input{
    width: 840px;
    height: 50px;
    border: 2px solid #767676;
    float: left;
    font-size: 14px;
    padding: 14px 30px 15px 30px;
    border-radius: 30px;
    color: #999;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    outline: none;
    box-sizing: border-box;
  }
  button {
    float: left;
    border-radius: 31px;
    height: 50px;
    border: 2px solid #4573e7;
    padding: 14px 56px 15px 56px;
    color: #4573e7;
    font-size: 16px;
    font-weight: 400;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    margin-left: 61px;
    box-sizing: border-box;
  }
}
</style>
